// extracted by mini-css-extract-plugin
module.exports = {"success":"success","content":"content","image":"image","title":"title","subtitle":"subtitle","success-btn":"success-btn"};